var scrollAnimatron = function(elements, delay) {
	var checkElements = [];

	var forEach = function(array, callback) {
		for (var i = 0; i < array.length; i++) {
			callback(array[i], i);
		};
	};

	function addClass(el, className) {
		if (el.classList) el.classList.add(className);
		else el.className += ' ' + className;
	};

	function removeClass(el, className) {
		if (el.classList) el.classList.remove(className);
		else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	};

	function check(el, offset, classAdd, offsetMobile, hidderClass, callback, i) {
		var offsett = offsetMobile ? offsetMobile : offset;
		var elTop = el.getBoundingClientRect().top,
			isOffset = (elTop + offsett) < window.innerHeight ? true : false;
		if (isOffset) {
			//checkElements.splice(i, 1);
			removeClass(el, hidderClass);
			addClass(el, classAdd);
			if (callback) callback(el);
		};
	};

	this.update = function() {
		checkElements = [];
		init();
	}

	this.add = function(el) {
		var	offset = el.offset || 0,
				classAdd = el.classAdd || 'is-animated',
				offsetMobile = el.offsetMobile || false,
				hidderClass = el.hidderClass || 'is-hidd',
				callback = el.callback || false;

		if (el.el) {
			checkElements.push({
				el: el.el,
				offset: offset,
				classAdd: classAdd,
				offsetMobile: offsetMobile,
				hidderClass: hidderClass,
				callback: callback
			});
			addClass(el.el, hidderClass);
			// check(el.el, offset, classAdd, offsetMobile, hidderClass);
		}
	}

	this.scroll = function() {
		if (checkElements.length > 0) {
			forEach(checkElements, function(el, i) {
				check(el.el, el.offset, el.classAdd, el.offsetMobile, el.hidderClass, el.callback, i);
			});
		};	
	};

	function init() {
		forEach(elements, function(el) {
			var	offset = el.offset || 0,
				classAdd = el.classAdd || 'is-animated',
				offsetMobile = el.offsetMobile || false,
				hidderClass = el.hidderClass || 'is-hidd',
				callback = el.callback || false,
				elements = Array.prototype.slice.call(document.querySelectorAll(el.el));

			forEach(elements, function(el) {
				addClass(el, hidderClass);
				if (delay) setTimeout(function () {
          check(el, offset, classAdd, offsetMobile, hidderClass);
        }, delay);
				else check(el, offset, classAdd, offsetMobile, hidderClass);

				checkElements.push({
					el: el,
					offset: offset,
					classAdd: classAdd,
					offsetMobile: offsetMobile,
					hidderClass: hidderClass,
					callback: callback
				});
			});
		});
	};

	init();
};

export { scrollAnimatron }